// Maps the real WhooLive ("LiveCam") backend payloads into the shapes the
// existing Web Portal UI already expects — so components/routes stay unchanged.
// The backend has no cover images / avatars / tags, so we fall back to
// category placeholder art and initials avatars (display-only, not invented data).

const CATEGORY_IMAGE = {
  news: "https://images.unsplash.com/photo-1684285746670-3d2eeed72192?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  music: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sports: "https://images.pexels.com/photos/35898730/pexels-photo-35898730.jpeg?auto=compress&cs=tinysrgb&w=1200",
  party: "https://images.unsplash.com/photo-1581417478175-a9ef18f210c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  food: "https://images.unsplash.com/photo-1535898331935-2d274aff0fbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  nature: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  emergency: "https://images.unsplash.com/photo-1684285746670-3d2eeed72192?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  other: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const categoryImage = (c) => CATEGORY_IMAGE[(c || "other").toLowerCase()] || CATEGORY_IMAGE.other;

// De-duplicated, human-readable location label (backend often repeats name===city).
export const locationLabel = (loc) => {
  const parts = [loc?.name, loc?.city].map((s) => (s || "").trim()).filter(Boolean);
  const unique = [...new Set(parts)];
  return unique.join(", ") || "Unknown location";
};

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export function mapEvent(be) {
  return {
    id: be.id,
    title: be.title,
    description: be.description || "",
    cover: (be.images && be.images[0]) || categoryImage(be.category),
    category: cap(be.category),
    startsAt: be.starts_at || be.start_time,
    endsAt: be.ends_at || null,
    price: "Free",
    type: "free",
    isLive: !!be.is_live,
    liveCount: be.live_count || 0,
    host: {
      id: be.created_by,
      username: be.created_by,
      displayName: be.created_by_name || "Host",
      avatar: "",
      verified: false,
    },
    location: {
      name: be.location_name || "",
      city: be.location_name || "",
      lat: be.lat,
      lng: be.lng,
    },
    attendees: be.participant_count || 0,
    capacity: null,
    tags: be.category ? [cap(be.category)] : [],
  };
}

export function mapStream(be, eventMap = {}) {
  const ev = eventMap[be.event_id];
  return {
    id: be.id,
    eventId: be.event_id,
    roomName: be.room_name,
    title: be.event_title || (ev && ev.title) || "Live stream",
    thumbnail: (ev && ev.cover) || categoryImage("other"),
    category: (ev && ev.category) || "Live",
    viewers: be.viewer_count || 0,
    isLive: be.status === "live",
    startedAt: be.started_at,
    host: {
      id: be.broadcaster_id,
      username: be.broadcaster_id,
      displayName: be.broadcaster_name || "Host",
      avatar: "",
      verified: false,
    },
    location: (ev && ev.location) || { name: "", city: "" },
    tags: (ev && ev.tags) || [],
  };
}

export function mapProfile(u) {
  return {
    id: u.id,
    username: u.id,
    displayName: u.name || "User",
    avatar: u.picture || "",
    bio: u.bio || "",
    location: "",
    followers: 0,
    following: 0,
    verified: false,
    tags: [],
  };
}

export function mapMessage(m) {
  return {
    id: m.id,
    userId: m.user_id,
    user: m.user_name || "user",
    text: m.text || m.content || "",
    ts: m.created_at,
  };
}
